import { API_USER_SERVICE } from "../config/Constants";
import { ICreateDepartmentDTO, ICreateRoleDTO, IUpdateDepartmentDTO } from "../interfaces/UserManagement";
import { getRequest, postRequest, putRequest } from "./Rest";

export const createDepartment = async(post:ICreateDepartmentDTO) =>{
    const path = `${API_USER_SERVICE}/department/create`;
    const response = await postRequest(path,post);
    return response;
};
export const getDepartmentList = async() =>{
    const path = `${API_USER_SERVICE}/department/list`;
    const response =  await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const searchFilterDepartment = async(statuses:string[],searchKeyword:string) =>{
    const parts: string[] = [];
    statuses.forEach((s) => parts.push(`status=${s}`));
    if (searchKeyword) parts.push(`searchKeyword=${searchKeyword}`);
    const params = parts.join("&");
    const path = `${API_USER_SERVICE}/department/list${params ? `?${params}` : ""}`;
    const response =  await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const updateDepartment = async(dto:IUpdateDepartmentDTO,departmentId:number) =>{
    const path = `${API_USER_SERVICE}/department/update/${departmentId}`;
    const response = await putRequest(path, dto);
    return response;
};
export const activateDeactivateDepartment = async(departmentId:number) =>{
    const path = `${API_USER_SERVICE}/department/toggle-status/${departmentId}`;
    const response = await putRequest(path,{});
    return response;
};
export const getDeptsMin = async() =>{
    const path = `${API_USER_SERVICE}/department/list/min`;
    const response =  await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getPermissionsMin = async() =>{
    const path = `${API_USER_SERVICE}/permission/list/min`;
    const response =  await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getRolesMin = async() =>{
    const path = `${API_USER_SERVICE}/role/list/min`;
    const response =  await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const createRole = async(post:ICreateRoleDTO) =>{
    const path = `${API_USER_SERVICE}/role/create`;
    const response = await postRequest(path, post);
    return response;
};
export const getRolesList = async() =>{
    const path = `${API_USER_SERVICE}/role/list`;
    const response =  await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const searchFilterRoles = async(statuses:string[],searchKeyword:string) =>{
    const parts: string[] = [];
    statuses.forEach((s) => parts.push(`status=${s}`));
    if (searchKeyword) parts.push(`searchKeyword=${searchKeyword}`);
    const params = parts.join("&");
    const path = `${API_USER_SERVICE}/role/list${params ? `?${params}` : ""}`;
    const response =  await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getRoleDeptsperms = async(roleId:number) =>{
    const path = `${API_USER_SERVICE}/role/departments-permissions/${roleId}`;
    const response =  await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const updateRole = async(dto:ICreateRoleDTO, roleId:number) =>{
    const path = `${API_USER_SERVICE}/role/update/${roleId}`;
    const response = await putRequest(path, dto);
    return response;
};
export const activateDeactivateRole = async(roleId:number) =>{
    const path = `${API_USER_SERVICE}/role/toggle-status/${roleId}`;
    const response = await putRequest(path,{});
    return response;
};
export const getUserList = async() =>{
    const path = `${API_USER_SERVICE}/user/list`;
    const response =  await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const searchFilterUsers = async(statuses:string[],roleIds:number[],departmentIds:number[],searchKeyword:string) =>{
    const parts: string[] = [];
    statuses.forEach((s) => parts.push(`status=${s}`));
    roleIds.forEach((id) => parts.push(`roleIds=${id}`));
    departmentIds.forEach((id) => parts.push(`departmentIds=${id}`));
    if (searchKeyword) parts.push(`searchKeyword=${searchKeyword}`);
    const params = parts.join("&");
    const path = `${API_USER_SERVICE}/user/list${params ? `?${params}` : ""}`;
    const response =  await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const resendInvite = async(userId:number) =>{
    const path = `${API_USER_SERVICE}/user/resend-invitation/${userId}`;
    const response = await postRequest(path, {});
    return response;
};
export const activateDeactivateUser = async(userId:number) =>{
    const path = `${API_USER_SERVICE}/user/toggle-status/${userId}`;
    const response = await putRequest(path,{});
    return response;
};
export const getUserDetails = async(userId:number) =>{
    const path = `${API_USER_SERVICE}/user/${userId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
